import { useEffect, useState } from 'react';
import api from 'services/api';
import Impressao from 'views/pages/ConfiguracaoImpressao/components/Impressao';

interface Props {
  configuracaoId: number;
}

export default function ImpressaoFT(props: Props): JSX.Element {
  const { configuracaoId } = props;

  const [tipoProduto, setTipoProduto] = useState('');

  async function buscarTipoProduto() {
    const response = await api.get(
      `/orcamento/versao/${configuracaoId}/buscar-produto`,
    );
    setTipoProduto(response.data.descritivo ?? '');
  }

  useEffect(() => {
    buscarTipoProduto();
  }, []);

  return (
    <>
      {configuracaoId && tipoProduto && (
        <Impressao
          orcamentoVersaoId={configuracaoId}
          tipoProduto="Irrigacao"
          isPrevia
        />
      )}
    </>
  );
}
